/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const encounterVisualCharts = sqliteTable('encounter_visual_charts', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  patient_id: text('patient_id'),
  encounter_id: text('encounter_id'),
  visit_id: text('visit_id'),
  chart_type: text('chart_type'),
  before_file_id: text('before_file_id'),
  after_file_id: text('after_file_id'),
  base_type: text('base_type'),
  base_image_id: text('base_image_id'),
  template_id: text('template_id'),
  drawing_data: text('drawing_data'),
  label: text('label'),
  sort_order: integer('sort_order'),
  created_by_user_id: text('created_by_user_id'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  updated_by: text('updated_by'),
});
